module.exports = __webpack_public_path__ + "static/media/grand_mum_friend_talking.f3b704f7.gif";